import React from 'react';
import { Dialog } from '@mui/material';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import DeviceSetting from './DeviceSetting';
import CloseButton from '../common/CloseButton';
import SettingIcon from '../common/Icons/Setting';
import { RootState } from '../../store';
import { SettingState } from '../../store/setting/types';
import { hideGlobalSetting } from '../../store/setting/actions';
import { useSelfViewContext } from '../../customer-call-sdk';

const StyledGlobalSetting = styled(Dialog)`
    z-index: 1502;

    .paper {
        width: 550px;
        padding: 2.5rem;
        position: relative;
        outline: none;
    }
    .setting-icon {
        width: 42px;
        height: 42px;
    }

    .close-icon {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
    }
`;
/**
 * Global Setting Dialog Container
 */

const GlobalSetting: React.FC = () => {
    const dispatch = useDispatch();
    const { isGlobalSettingVisible } = useSelector<RootState, SettingState>(
        (state) => state.setting,
    );
    const { turnedOff, turnOff } = useSelfViewContext();

    const handleClose = () => {
        if (turnedOff) {
            turnOff();
        }
        dispatch(hideGlobalSetting());
    };

    return (
        <StyledGlobalSetting
            open={isGlobalSettingVisible}
            disablePortal
            data-testid="global-setting-dialog"
            id="global-setting-dialog"
            PaperProps={{ className: 'paper' }}
            onClose={handleClose}
            keepMounted={false}
        >
            <div>
                <SettingIcon className="setting-icon " />
            </div>
            <DeviceSetting />
            <CloseButton id="close-btn" className="close-icon" onClick={handleClose} />
        </StyledGlobalSetting>
    );
};

export default GlobalSetting;
